import type { IdDocumentType } from '../person';

export function shouldAskForAdditionalId(mainIdType?: IdDocumentType | null) {
  return !mainIdType || !['UMID', 'SSS'].includes(mainIdType);
}
